import React, { useState, useEffect, useRef } from "react";

import "../../css/MessageBTN.css";

import chat_icon from "../../assets/chat.png";

const MessageBTN = (props) => {
  const [openMessage, setOpenMessage] = useState(false);
  const [showText, setShowText] = useState(true);
  const ramdomVersion = Math.floor(Math.random() * 100000) + 1;

  useEffect(() => {
    const timer = setTimeout(() => setShowText(false), 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
  <div className="container-message-btn">
    {openMessage ? (
      <div className="hover-message">
        <iframe src={`https://chat.traffy.in.th/?version=${ramdomVersion}&messageID=${props?.data?.message_id}&bypassLineAuth=true&ticketID=${props?.data?.ticket_id}&lang=${props?.data?.lang}&showTicketID=false`} width="390" height="710" title="Talk to a staff">
        </iframe>
        {/* <iframe src={`http://localhost:5173/?version=${Math.floor(Math.random() * 100000) + 1}&messageID=${props?.data?.message_id}&bypassLineAuth=true&ticketID=${props?.data?.ticket_id}&lang=${props?.data?.lang}&showTicketID=false`} width="390" height="710" title="Talk to a staff">
        </iframe> */}
        <svg style={{ marginLeft: "-32px", backgroundColor: "rgba(232, 222, 248, 1)", borderRadius: "100px" }} onClick={() => setOpenMessage(!openMessage)} fill="none" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg" id="fi_5368396"><path d="m18.8071 6.6071c.3905-.39052.3905-1.02369 0-1.41421-.3905-.39053-1.0237-.39053-1.4142 0l-5.3929 5.39291-5.3929-5.39291c-.39052-.39053-1.02369-.39053-1.41421 0-.39053.39052-.39053 1.02369 0 1.41421l5.39291 5.3929-5.39291 5.3929c-.39053.3905-.39053 1.0237 0 1.4142.39052.3905 1.02369.3905 1.41421 0l5.3929-5.3929 5.3929 5.3929c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-5.3929-5.3929z" fill="rgb(0,0,0)"></path></svg>
      </div>
    ) : (
      // <span className="hover-text">
      //   {props?.data?.lang === 'th' ? "คุยกับเจ้าหน้าที่" : "Talk to a staff"}
      // </span>
      null
    )}
    <div className="container-chat-icon">
      <div className="chat-icon" onClick={() => setOpenMessage(!openMessage)}>
        <img src={chat_icon} style={{ height: "32px", width: "32px" }} />
        {showText &&
          <span className="chat-text">{props?.data?.lang === 'th' ? "คุยกับเจ้าหน้าที่" : "Talk to a staff"}</span>
        }
      </div>
    </div>
  </div>
</>

  );
};

export default MessageBTN;
